// Shared intent → human-readable label map.
// Used by both StepUpModal (auth banner) and ActionModal (action header).
// READ: apps/admin/src/components/admin/action-modal.tsx for the authoritative
// action intent union.

export const INTENT_LABELS: Record<string, string> = {
  'account-lock':    'Lock Account',
  'account-unlock':  'Unlock Account',
  'fedjail':         'Federal Jail',
  'fedjail-clear':   'Clear Federal Jail',
  'force-logout':    'Force Logout',
  'password-reset':  'Reset Password',
  'recover-email':   'Issue Account Recovery',
  'disable-2fa':     'Disable 2FA',
  'ip-ban':          'Ban IP',
  'ip-unban':        'Unban IP',
  'support-claim':   'Claim Support Request',
  'support-resolve': 'Resolve Support Request',
  'config-publish':  'Publish config change',
  'config-restore':  'Restore config revision',
  'payment-note':    'Add investigation note',
  'create-staff':    'Create Staff Account',
  'webauthn-delete-last': 'Remove Last Passkey',
};

/** Intents that require the destructive visual treatment in the step-up banner. */
export const DESTRUCTIVE_INTENTS = new Set([
  'account-lock',
  'fedjail',
  'force-logout',
  'disable-2fa',
  'ip-ban',
  'webauthn-delete-last',
]);

export function getIntentLabel(intent: string): string {
  return INTENT_LABELS[intent] ?? intent;
}

export function isDestructiveIntent(intent: string): boolean {
  return DESTRUCTIVE_INTENTS.has(intent);
}
